import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUser, getAuth } from '../store/user/selectors';
import Logo from '../assets/images/01.png'

const Appfooter = () => {
    const auth = useSelector(getAuth);
    const user = useSelector(getUser)
        return (
            <div className="app-footer border-0 shadow-lg">
                <Link to="/home" className="nav-content-bttn nav-center"><i className="feather-home"></i></Link>
                <Link to="/defaultbadge" className="nav-content-bttn"><i className="feather-package"></i></Link>
                <Link to="/defaultstorie" className="nav-content-bttn" data-tab="chats"><i className="feather-layout"></i></Link>           
                <Link to="/shop2" className="nav-content-bttn"><i className="feather-layers"></i></Link>
                <Link to="/defaultsettings" className="nav-content-bttn"><img src={auth ? user.picture : Logo} alt="user" className="rounded-circle w30 shadow-xss" /></Link>
            </div>        
        );
    }

export default Appfooter;